"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RemoteTrackController = exports.LocalTrackController = exports.TrackController = void 0;
const Connection_1 = require("./Connection");
const Listener_1 = require("./Listener");
class TrackController extends Listener_1.default {
    constructor(negotiators) {
        super();
        this.negotiators = Array.isArray(negotiators) ? negotiators : [negotiators];
        this.tracks = new Map();
    }
}
exports.TrackController = TrackController;
class LocalTrackController extends TrackController {
    constructor(negotiators, factory) {
        super(negotiators);
        this.factory = factory;
        this.negotiators.map(n => n.negotiate(Array.from(this.tracks.values())));
    }
    addNegotiator(negotiator) {
        const idx = this.negotiators.findIndex(p => p === negotiator);
        if (idx !== -1) {
            return;
        }
        this.negotiators.push(negotiator);
        return Promise.all(this.negotiators.map(n => n.negotiate(Array.from(this.tracks.values()))));
    }
    removeNegotiator(negotiator) {
        const idx = this.negotiators.findIndex(p => p === negotiator);
        if (idx === -1) {
            return;
        }
        this.negotiators.splice(idx, 1);
        return Promise.all(this.negotiators.map(n => n.negotiate(Array.from(this.tracks.values()))));
    }
    clearNegotiators() {
        this.negotiators = [];
    }
    add(trackType) {
        return __awaiter(this, void 0, void 0, function* () {
            const req = Array.isArray(trackType) ? trackType : [trackType];
            const tracks = yield this.factory.createTracks(req);
            tracks.forEach((t) => {
                this.tracks.set(t.type, t);
                this.fire(new Connection_1.TrackAdded(t));
                t.track.onended = () => {
                    t.stop();
                    this.remove(t.type);
                };
            });
            yield Promise.all(this.negotiators.map(n => n.negotiate(Array.from(this.tracks.values()))));
        });
    }
    remove(trackType) {
        return __awaiter(this, void 0, void 0, function* () {
            const req = Array.isArray(trackType) ? trackType : [trackType];
            req.forEach((type) => {
                this.tracks.delete(type);
                this.fire(new Connection_1.TrackRemoved(type));
            });
            yield Promise.all(this.negotiators.map(n => n.negotiate(Array.from(this.tracks.values()))));
        });
    }
}
exports.LocalTrackController = LocalTrackController;
class RemoteTrackController extends TrackController {
    constructor(negotiator) {
        super(negotiator);
        this.onTrackChanged = (ev) => {
            if (ev.constructor === Connection_1.TrackAdded) {
                this.tracks.set(ev.track.type, ev.track);
                super.fire(ev);
            }
            else if (ev.constructor === Connection_1.TrackRemoved) {
                this.tracks.delete(ev.type);
                super.fire(ev);
            }
        };
        negotiator.on(this.onTrackChanged);
    }
    switchNegotiator(negotiator) {
        this.negotiators.forEach(n => n.off(this.onTrackChanged));
        this.negotiators = [negotiator];
        negotiator.on(this.onTrackChanged);
    }
    request(trackType) {
        return __awaiter(this, void 0, void 0, function* () {
            const req = Array.isArray(trackType) ? trackType : [trackType];
            return Promise.all(this.negotiators.map(n => n.negotiate(undefined, req)));
        });
    }
    remove(trackType) {
        return __awaiter(this, void 0, void 0, function* () {
            const req = Array.isArray(trackType) ? trackType : [trackType];
            return Promise.all(this.negotiators.map(n => n.negotiate(undefined, req)));
        });
    }
}
exports.RemoteTrackController = RemoteTrackController;
//# sourceMappingURL=TrackController.js.map